import React, { useContext, useState } from "react";
import "./communication-tab.component.scoped.scss";
import { ReporterCommunicationTimelineComponent } from "../reporter-communication-timeline/reporter-communication-timeline.component";
import { FilesUploadSectionComponent } from "../files-upload-section/files-upload-section.component";
import FilesDropZone from "../files-drop-zone/files-drop-zone.component";
import { CaseContext } from "../../store";
import { useTranslation } from "react-i18next";

export const ReporterCommunicationTabComponent = (props: any) => {
  const { caseDetails } = useContext(CaseContext);
  const [t] = useTranslation();
  const [files, setFiles] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  return (
    <FilesDropZone onDropFiles={setFiles} isSaving={isSaving}>
      <div className="theme-container reporter-communication-tab">
        <ReporterCommunicationTimelineComponent />
      </div>

      {(caseDetails.status !== "ABGESCHLOSSEN" && caseDetails.status !== "Completed") && <div className="sticky-container">
        <div className="theme-container">
          <FilesUploadSectionComponent
            tab="reporter"
            droppedFiles={files}
            label={t("add file and description to communicate with reporter")}
            onUploadingFiles={setIsSaving}
          />
        </div>
      </div>}
    </FilesDropZone>
  );
};
